
import { updateAppConfig } from '#app/config'
import { defuFn } from 'defu'

const inlineConfig = {
  "environment": "production",
  "url": "https://lemonsqueezy.com",
  "domain": "lemonsqueezy.com",
  "nuxt": {
    "buildId": "90cd2ce2-a1c5-4f79-8662-7fd2ab742809"
  }
}

// Vite - webpack is handled directly in #app/config
if (import.meta.hot) {
  import.meta.hot.accept((newModule) => {
    updateAppConfig(newModule.default)
  })
}



export default /*@__PURE__*/ defuFn(inlineConfig)
